export default __webpack_public_path__ + "static/media/settings.014f8712.svg";